export default __webpack_public_path__ + "static/05-ace860615038fef3df55b50bfa5b15fe.png";